import * as SearchActions from '../../state/search/search.action';

import template from './maintenance-btn-group.template.html';

export class MaintenanceBtnGroupController {
  constructor($ngRedux) {
    'ngInject';

    this.store = $ngRedux;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, SearchActions)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  mapStateToThis(state) {
    const {maintenance} = state.search;
    return {maintenance};
  }

  updateMaintenanceFacet(status) {
    if (status._selected) {
      this.selectFacet(SearchActions.MAINTENANCE_STATUS_FACET_TYPE, status);
    } else {
      this.deselectFacet(SearchActions.MAINTENANCE_STATUS_FACET_TYPE, status);
    }
  }
}

export const MaintenanceBtnGroupComponent = {
  template,
  bindings: {},
  controller: 'MaintenanceBtnGroupController as vm'
};
